import React from "react"
import { Col, Container, Row } from "reactstrap"
import * as s from "./style.module.css"
import Dots from "../Dots/index"
import useLabels from "../../utils/useLabels"

import labels from "../Summary2020/const"
import Numbers from "../Numbers"
import { PartnersCard } from "../Partners"
import WorkshopsFull from "../WorkshopsFullDesc"
import MentorsFull from "../MentorsWithDesc"
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

export default function Summary2020({ lang }) {
  const t = useLabels(labels, lang)

  return (
    <div className={s.root}>
      <Container className="mb-5">
        <div className={s.header}>
          <h2>{t.data2020.title}</h2>
          <div className={s.divider} />
        </div>

        <div
          className="text-left"
          dangerouslySetInnerHTML={{ __html: t.data2020.description }}
        ></div>

        <Numbers type="summary2020" />

        {/* Projects section */}
        <div className="mt-5">
          <div className={s.header}>
            <h2>{t.projects2020.projectsTitle}</h2>
            <div className={s.divider} />
          </div>

          <div className={s.header}>
            <h3 dangerouslySetInnerHTML={{ __html: t.projects2020.title }} />
            <div className={s.divider} />
          </div>
          <p
            className={s.text}
            dangerouslySetInnerHTML={{ __html: t.projects2020.summary }}
          />
        </div>
      </Container>

      <div className={[s.bgWrapper, "px-5"].join(" ")}>
        <div className="position-relative">
          <Col>
            <div className={[s.project, s.winners, s.highlight].join(" ")}>
              <div className="d-flex flex-column flex-md-row">
                <img
                  alt=""
                  className={[s.img].join(" ")}
                  src={t.projects2020.winners.image}
                />
                <div className={s.dotsWrapper2}>
                  <Dots x={4} y={4} color="black" />
                </div>
                <div className="w-100">
                  <h1 className={s.winnersTitle}>
                    {t.projects2020.winners.name}
                  </h1>
                  <h5 className={[s.place, "text-center"].join(" ")}>
                    {t.projects2020.winners.place}
                  </h5>
                </div>
              </div>
              <div
                className={s.text}
                dangerouslySetInnerHTML={{
                  __html: t.projects2020.winners.text,
                }}
              />
            </div>
          </Col>

          <Row xs={1} md={2} lg={3}>
            {t.projects2020.projects.map(project => (
              <Col className="mb-4">
                <Project {...project} />
              </Col>
            ))}
          </Row>
        </div>
      </div>

      <section id="workshop-2020">
        <WorkshopsFull workshops={t.workshops2020} />
      </section>

      <section id="mentors-2020">
        <MentorsFull mentors={t.mentors2020} />
      </section>

      <section id="partners-2020">
        <div className={s.root}>
          <Container className={s.container}>
            <div className={s.header}>
              <h2>{t.partners2020.title}</h2>
              <div className={s.divider} />

              {t.partners2020.logos.map(({ title, elements }) => (
                <PartnersCard title={title} elements={elements} />
              ))}
            </div>
          </Container>
        </div>
      </section>
    </div>
  )
}

function Project({ text, name, image, place, posX, posY }) {
  const dostStyle = {
    position: "absolute",
    top: posX,
    left: posY,
    transform: "scale(1.6)",
    zIndex: 0,
  }

  return (
    <div
      className={[
        s.project,
        name === "ADMD" || name === "Flower Power" || name === "Ekoninja"
          ? s.highlight
          : "",
      ].join(" ")}
    >
      <div className="d-flex">
        <div className={s.imgWrapper}>
          <LazyLoadImage alt="" effect="blur" className={s.img} src={image} />
          {/*<div style={dostStyle}>*/}
          {/*  <Dots x={4} y={4} color="black" />*/}
          {/*</div>*/}
        </div>
      </div>

      <h4 className={s.projectTitle}>{name}</h4>
      <h5 className={s.place}>{place}</h5>
      <p className={s.text} dangerouslySetInnerHTML={{ __html: text }} />
    </div>
  )
}
